import Service from "@ember/service";
import type { Chart } from "chart.js";

export default class ChartJSService extends Service {
  isRegistered = false;

  async register(): Promise<typeof Chart> {
    return import("chart.js").then(
      ({
        Chart,
        LinearScale,
        LineController,
        LineElement,
        PointElement,
        TimeScale,
        Legend,
        Tooltip,
        Filler
      }) => {
        return import("chartjs-adapter-dayjs-3").then(() => {
          if (this.isRegistered) return Chart;

          Chart.register(
            LineController,
            LinearScale,
            TimeScale,
            PointElement,
            LineElement,
            Legend,
            Tooltip,
            Filler
          );

          this.isRegistered = true;
          return Chart;
        });
      }
    );
  }
}

declare module "ember__service" {
  interface Registry {
    chartjs: ChartJSService;
  }
}
